import React from "react";
import Image from "next/image";
import KnowMore from "@/components/ui/know-more";
export default function Insights({ data }) {
  return (
    <>
      <div className="grid grid-cols-1 auto-rows-auto w-full md:gap-12 gap-16 mb-0">
        {data.map((row, key) => (
          <Block
            data={row}
            key={"insight" + key}
            reverse={key % 2 !== 0 ? true : false}
          />
        ))}
      </div>
      {/* <KnowMore
        path="#"
        text="For more on internal migration in South and Southeast Asia, read our report"
        external={true}
        className="mx-auto"
        variant="darkBlue"
      /> */}
    </>
  );
}

const Block = ({ data, reverse }) => {
  const { heading, text, image } = data;
  return (
    <div>
      <div
        className={`w-full lg:items-center flex md:gap-8 gap-4 ${
          reverse ? "lg:flex-row-reverse flex-col" : "lg:flex-row flex-col"
        } h-[auto]`}
      >
        <div className="relative lg:w-[400px] lg:h-[350px] md:w-full md:h-[250px] w-full h-[200px] shrink-0 rounded-2xl overflow-hidden">
          <Image
            src={image}
            alt={heading}
            fill
            className="object-cover object-center rounded-2xl shrink-0"
            sizes="(max-width: 479px) 768px,(max-width: 768px) 768px, (max-width: 1200px) 768px,(max-width: 1920px) 768px, 768px"
          />
        </div>

        <div className={`flex flex-col w-full h-full justify-around`}>
          <h4 className="lg:text-2xl text-base text-justify mb-4 font-semibold leading-tight text-darkBlue">
            {heading}
          </h4>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="text-paragraph font-normal lg:text-base text-sm [&>sup]:text-lightBlue text-justify"
          />
        </div>
      </div>
      {data.extra && (
        <div
          className="mt-3 text-body font-normal text-xs"
          dangerouslySetInnerHTML={{ __html: data.extra }}
        />
      )}
    </div>
  );
};
